{
  "manage": {
    "title": "Manage Forms"
  },
  "workflows": {
    "add_to_list": {
      "list_name_label": "List Name"
    },
    "follow_up_campaign": {
      "campaign_name_label": "Campaign Name"
    },
    "validation": {
      "list_required": "Please choose a list",
      "campaign_required": "Please choose a campaign"
    }
  },
  "settings": {
    "theme": "Theme",
    "default_confirmation_page": "Default Confirmation Page",
    "waitlist": "Waitlist",
    "expiry_date": "Expiry Date",
    "log_key_activities": "Log Key Activities",
    "set_consent_status": "Set consent status to given",
    "include_default_footer": "Include Default Footer",
    "key_activity": {
      "type_label": "Type",
      "create_activity_label": "Create activity",
      "validation": {
        "activity_type_required": "Please choose activity type",
        "activity_title_required": "Please choose an activity"
      }
    },
    "theme_settings": {
      "include_default_footer_label": "Include Default Footer",
      "enable_recaptcha_label": "Enable reCAPTCHA"
    },
    "success_message": "Success! Your changes have been saved."
  },
  "fields": {
    "input_label": "Input Label",
    "description_optional": "Field Description (Optional)",
    "default_values": "Default Values",
    "display_view": "Display View",
    "required": "Required",
    "hide_field": "Hide Field",
    "content": "Content",
    "message": "Message",
    "activity": "Activity",
    "description": "Description",
    "to": "To",
    "value": "Value",
    "field": "Field",
    "select_field": "Select Field",
    "field_required": "Please select a field",
    "form_elements": {
      "elements_title": "Elements",
      "fields_title": "Fields",
      "add_field_button": "Add Field",
      "text_field": "Text"
    },
    "default_fields": {
      "first_name": "First Name",
      "last_name": "Last Name",
      "twitter": "Twitter",
      "first_name_label": "Enter your first name",
      "first_name_placeholder": "Type here...",
      "last_name_label": "Enter your last name",
      "last_name_placeholder": "Type here...",
      "job_title_label": "Enter your job title",
      "job_title_placeholder": "Type here...",
      "linkedin_url_label": "Enter your LinkedIn URL",
      "linkedin_url_placeholder": "Type here...",
      "twitter_url_label": "Enter your Twitter URL",
      "twitter_url_placeholder": "Type here...",
      "street_address_label": "Enter your street address",
      "street_address_placeholder": "Type here...",
      "city_label": "Enter your city",
      "city_placeholder": "Type here...",
      "country_label": "Enter your country",
      "country_placeholder": "Type here...",
      "zip_label": "Enter your postal zip code",
      "zip_placeholder": "Type here...",
      "state_label": "Enter your state",
      "state_placeholder": "Type here...",
      "consent_label": "I agree to receive marketing communications and understand I can unsubscribe at any time."
    },
    "required_label": "Required",
    "email_required_tooltip": "Email is required as identifiers in the systems.",
    "more_actions": "More actions",
    "more_actions_aria": "more actions",
    "form_element_aria": "form element",
    "edit_details": "Edit Details",
    "description_label": "Description",
    "description_placeholder": "Type here ...",
    "drag_drop_instruction": "Drag and drop the field here to fill the form",
    "remove_field_confirmation": "Are you sure you want to remove this field?",
    "remove_field_title": "Remove Form Field",
    "remove_field_aria": "remove form field",
    "title_label": "Title"
  },
  "tabs": {
    "fields": "Fields",
    "settings": "Settings"
  },
  "placeholders": {
    "type_label": "Type label",
    "input_information": "Input information to fill the fields",
    "type_default_values": "Type default values",
    "type_activity_title": "type activity title",
    "type_activity_description": "type activity description",
    "enter_text_content": "Enter the text content",
    "type_here": "Type here..."
  },
  "display_options": {
    "dropdown": "Dropdown",
    "list": "List"
  },
  "workflow": {
    "add_conditions": "Add Conditions",
    "remove_workflow": "Remove Workflow",
    "actions": "Actions",
    "confirm_remove_title": "Remove Workflow",
    "confirm_remove_content": "Are you sure you want to remove this workflow?",
    "add_workflow_button": "+ Add Workflow",
    "save_cancel_tooltip": "Please save or cancel your current changes first",
    "add_condition_button": "Add Condition",
    "condition_modal_title": "Condition",
    "condition_modal_caption": "Do the action only when this condition is met.",
    "field_selection_error": "Please select a field",
    "value_selection_error": "Please select a value"
  },
  "text_element": "Text",
  "text_element_placeholder": "Replace with your text",
  "forms": {
    "confirmation": {
      "thank_you": "Thank you",
      "default_message": "Thank you for submitting the form. Your information has been successfully received.",
      "redirect_message": "You are being redirected to",
      "nexl_branding": "This form was created using Nexl. Explore",
      "learn_more": "to learn more",
      "header_label": "Header",
      "header_placeholder": "Type header",
      "message_label": "Message",
      "message_placeholder": "Type message",
      "redirect_link_label": "Redirect Link",
      "redirect_link_placeholder": "Paste your website link here."
    },
    "waitlist": {
      "settings": {
        "description": "Adjust your waitlist settings, including conditions and redirect URL",
        "enable_label": "Enable Waitlist",
        "redirect_url_label": "Redirect URL",
        "redirect_url_placeholder": "Paste URL here"
      },
      "condition": {
        "label": "Condition",
        "add_button": "Add Condition",
        "modal_title": "Condition",
        "modal_caption": "Do the action only when this condition is met.",
        "rollup_field_label": "Rollup Field",
        "no_rollup_field_option": "No rollup is related to this list",
        "operation_label": "Operation",
        "value_label": "Value",
        "operation_value_label_greater_than_or_equal_to": "is greater than or equal to",
        "operation_value_label_is": "is",
        "rollup_field_tooltip": "Roll-up field is required to use the waitlist feature. You can create one via the Workspace action menu."
      },
      "validation": {
        "redirect_url_invalid": "Please enter a valid URL",
        "redirect_url_required": "Redirect URL is required",
        "value_number_required": "Please enter a number",
        "value_integer_required": "Value must be an integer",
        "value_positive_required": "Value must be greater than 0",
        "value_required": "Please enter a value",
        "condition_required": "Please add a condition"
      }
    }
  },
  "cover_photo": {
    "title": "Cover Photo",
    "add_button": "Add Cover Photo",
    "upload_placeholder": "Drag and drop the image or click here to upload.\n          Accepted format: JPEG, PNG. Maximum size: 50MB. Aspect Ratio: 5:1 (for eg. 3000 x 600 px)",
    "delete_confirmation": "Click confirm to delete cover photo"
  },
  "publish": {
    "button": "Publish",
    "preview_button": "Preview",
    "embed_title": "Embed Form",
    "link_title": "Link",
    "download_qr": "Download QR"
  },
  "status": {
    "saving_changes": "Saving changes.Please wait...",
    "unsaved_warning": "Your changes have not been saved yet. Click \"Save\" to save your changes."
  }
}
